import { render, staticRenderFns } from "./WeekHeader.vue?vue&type=template&id=f36df2f8&scoped=true&"
import script from "./WeekHeader.vue?vue&type=script&lang=js&"
export * from "./WeekHeader.vue?vue&type=script&lang=js&"
import style0 from "./WeekHeader.vue?vue&type=style&index=0&id=f36df2f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36df2f8",
  null
  
)

export default component.exports